import $ from 'jquery';

Drupal.behaviors.troaxProductListFilter = {
  attach() {
    $('.filter-navbar')
      .once('troaxProductListFilter')
      .each((index, element) => this.productListFilter(element));
  },

  productListFilter() {
    // Constants.
    // const $window = $(window);
    const icon = $('.filter-navbar .fa-sliders-h');
    const filterForm = $('.filter-form');
    const close = $('.filter-form-header a');
    const body = $('body');
    const form = $('#views-exposed-form-products-product-list');

    function toggleModal(e) {
      e.preventDefault();
      filterForm.toggleClass('filter-form--modal');
      body.addClass('modal-open');

      if (!filterForm.hasClass('filter-form--modal')) {
        body.removeClass('modal-open');
      }
    }

    function removeScrollLock() {
      body.removeClass('modal-open');
    }

    // Events
    icon.on('click', toggleModal);
    close.on('click', toggleModal);
    form.on('change', removeScrollLock);
  },
};
